// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"39f70bb5","455":"46f755a4","977":"bdf53389"}[chunkId] + ".chunk.js";
};